import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import usePut from '../../../core/composables/api/usePut'
import type { Member } from '../../../core/models/member/member'
import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { useSnackStore } from '../../../stores/snack.store'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import { useApplicationModule } from '@/core/composables/use-application-module'
import { ApplicationModule } from '@/core/models/organization'
import { useI18n } from 'vue-i18n'

export const useCoachingInvitations = () => {
  const snackStore = useSnackStore()
  const { t } = useI18n()

  const {
    data: coachingInvitations,
    load: loadCoachingInvitations,
    status: coachingInvitationsStatus,
  } = useGet<
    {
      coach: Member
      createdAt: string
    }[]
  >('coaching/invitations')

  const { mutate, status: updateCoachingInvitationStatus } = usePut<
    void,
    {
      coachId: string
      coacheeId: string
      status: CoachingStatus
    }
  >('coaching/invitation')

  const taskBus = useEventBus(EventKey.taskUpdated)

  const updateCoachingInvitation = async (
    coachId: string,
    coacheeId: string,
    status: CoachingStatus,
  ) => {
    await mutate({ coachId: coachId, coacheeId: coacheeId, status: status })

    if (updateCoachingInvitationStatus.value == ApiRequestStatus.Success) {
      await loadCoachingInvitations()
      taskBus.emit()
      if (status == CoachingStatus.Active) {
        snackStore.showInfo(t('coaching.invitation.feedback.accepted'))
      } else {
        snackStore.showInfo(t('coaching.invitation.feedback.rejected'))
      }
    } else {
      snackStore.showError('Etwas ist schief gegangen!')
    }
  }

  const { hasModule } = useApplicationModule()

  onMounted(() => {
    if (hasModule(ApplicationModule.COACHING)) {
      loadCoachingInvitations()
    }
  })

  return {
    coachingInvitationsStatus,
    coachingInvitations,
    loadCoachingInvitations,
    updateCoachingInvitation,
    updateCoachingInvitationStatus,
  }
}

export enum CoachingStatus {
  Pending = 'pending',
  Active = 'active',
  Rejected = 'rejected',
}
